import { render, staticRenderFns } from "./NearByUsers.vue?vue&type=template&id=1a0c3313"
import script from "./NearByUsers.vue?vue&type=script&lang=js"
export * from "./NearByUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports